import { schoolTokenAxios } from "../axios";

const SCHOOL_BASE = process.env.REACT_APP_SCHOOL_BASE;
let schoolManagement = `${SCHOOL_BASE}/schoolManagement`;

export const getTextSmsSetting = (params) => {
  return schoolTokenAxios.get(`${schoolManagement}/getTextSmsSetting`, {
    params: params,
  });
};

export const updateSmsSetting = (body) => {
  return schoolTokenAxios.put(`${schoolManagement}/updateSmsSetting`, body);
};


export const getSessionSerialNumber = (params) => {
  return schoolTokenAxios.get(
    `${schoolManagement}/getSessionSerialNumber`,
    {
      params: params,
    }
  );
}

export const updateSessionSerialNumber = (body, params) => {
  return schoolTokenAxios.put(
    `${schoolManagement}/updateSessionSerialNumber`,
    body,
    {
      params,
    }
  );
};

export const getSessionIndependentSerialNumber = () => {
  return schoolTokenAxios.get(
    `${schoolManagement}/getSessionIndependentSerialNumber`
  );
};

export const updateSessionIndependentSerialNumber = (params) => {
  return schoolTokenAxios.put(
    `${schoolManagement}/updateSessionIndependentSerialNumber`,
    params
  );
};

